export default () => {

    return {
        // Optional visibility check for the TWIA visibility namespace
        'optionalVisibility_TWIA': (cond, target) => {
            return cond ? target : 'OPTIONAL';
        },
        // Base functionality only supports entry of addresses for the country that is configured as the default locale in
        // the core product.  This customization supports entry of addresses for all countries.
        'validatePostalCode_TWIA': (country, postalCode) => {
            if (postalCode) {
                switch (country.code) {
                    case 'US':
                        return postalCode.match(/^[0-9]{5}(-[0-9]{4})?$/) !== null;
                    case 'AU':
                        return postalCode.match(/^[0-9]{4}$/) !== null;
                    case 'CA':
                        return postalCode.match(/^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY][0-9][a-zA-Z] [0-9][a-zA-Z][0-9]$/) !== null;
                    case 'DE':
                        return postalCode.match(/^[0-9]{5}$/) !== null;
                    case 'FR':
                        return postalCode.match(/^[0-9]{5}$/) !== null;
                    case 'GB':
                        return postalCode.match(/.+/) !== null;
                    case 'JP':
                        return postalCode.match(/^[0-9]{3}-[0-9]{4}$/) !== null;
                    default:
                        console.warn(`validatePostalCode - unsupported country ${country.code}`);

                        return true;
                }
            }
        }
    };
};
